import { orderDelete } from '../../../redux/actions/order/orderActions';
import Alert from '../../../itrust_common/components/Alert';
import { humanize } from '../../../itrust_common/components/HelperFunctions';
import { patientLoad } from '../../../redux/actions/patient/patientActions';
import DateFormatView from '../../../itrust_common/components/others/DateFormatView';
import { useDispatch } from 'react-redux';

export default function DeleteOrderButton(props) {
  const { order, children, onDeleteHook } = props;
  const dispatch = useDispatch()

  const handleOrderDelete = (id) => {
    Alert.deleteConfirm(<div>
      This action cannot be undone. The order <strong>{order.id}</strong> of <strong>{humanize(order.patient_attributes.name)}</strong> created on <strong><DateFormatView date={order.order_date} /></strong> would be permanently deleted and won't be recovered back. Are you sure to delete it?
    </div>,
      (res) => {
        if (res) {
          dispatch(orderDelete(id))
            .then(() => dispatch(patientLoad(order.patient_attributes.id, { include: '*' })))
          onDeleteHook && onDeleteHook()
        }
      }
    )
  }

  return (
    <span className="pointer" onClick={() => handleOrderDelete(order.id)}>
      {children}
    </span>
  )
}
